import { ref } from 'vue'
import { loadYmapsScript } from '../ymap'

const YMAPS_TIMEOUT_MS = 6000

/**
 * Определяет доступность Yandex Maps для выбора провайдера inventory-карты.
 * Поддерживает принудительный OSM-режим через VITE_FORCE_OSM и не обращается к ymaps3 без проверки.
 *
 * @returns реактивное состояние проверки и доступности Yandex Maps
 */
export const useMapProvider = () => {
  const isChecking = ref(true)
  const isYmapsAvailable = ref(false)

  if (import.meta.env.VITE_FORCE_OSM === 'true') {
    isChecking.value = false

    return { isChecking, isYmapsAvailable }
  }

  Promise.race<boolean>([
    loadYmapsScript()
      .then(() => window.ymaps3?.ready ?? Promise.reject(new Error('Yandex Maps is unavailable')))
      .then(() => true)
      .catch(() => false),
    new Promise<boolean>((resolve) => {
      window.setTimeout(() => resolve(false), YMAPS_TIMEOUT_MS)
    }),
  ]).then((isAvailable) => {
    isYmapsAvailable.value = isAvailable
    isChecking.value = false
  })

  return { isChecking, isYmapsAvailable }
}
